module.exports = __webpack_public_path__ + "img/tip2.f2d7ed46.png";